// src/components/reports/Trend.tsx — YoY delta chip. Green up / red down,
// computed client-side from fyToDate vs fyPrevToDate. Ported from the prototype.

import { C, F } from "../../theme";
import { pct } from "../../lib/reports";

export const Trend = ({
  delta,
  suffix = "vs last yr",
  size = 12,
}: {
  delta: number;
  suffix?: string;
  size?: number;
}) => {
  const up = delta >= 0;
  const col = up ? C.sageDk : C.signalDk;
  const bg = up ? C.sageBg : C.signalBg;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "3px 8px",
        borderRadius: 8,
        background: bg,
        color: col,
        fontFamily: F.body,
        fontWeight: 800,
        fontSize: size,
        letterSpacing: 0.2,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ fontSize: size + 2, lineHeight: 1 }}>{up ? "▲" : "▼"}</span>
      {pct(delta)} <span style={{ fontWeight: 700, opacity: 0.7 }}>{suffix}</span>
    </span>
  );
};
